var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucceeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29721 0C3.30326 0 0.0539551 3.2493 0.0539551 7.24321C0.0539551 12.1998 6.53595 19.4763 6.81193 19.7837C7.07115 20.0724 7.52373 20.0719 7.78248 19.7837C8.05846 19.4763 14.5405 12.1998 14.5405 7.24321C14.5404 3.2493 11.2911 0 7.29721 0Z",
    fill: "#80CC39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucceeded);
export default __webpack_public_path__ + "static/media/succeeded.bf425afb8a4e4055b2b7ae3b8fe7e16d.svg";
export { ForwardRef as ReactComponent };